<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
}
</script>

<style>
html, body {
  padding: 0;
  margin: 0;
  font-family: 'Noto Sans JP', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1088px;
}
td {
  vertical-align: middle !important;
}
.modal-content {
  overflow: visible !important;
}
</style>
